export default {
  'Contáctanos': 'Contact Us',
  'Nosotros': 'About us',
  'Beneficios': 'Benefits',
  'Servicios': 'Services',
  'Casos de uso': 'Use Cases',
};